import { render, staticRenderFns } from "./updateDatosParaDebito.vue?vue&type=template&id=32da06f0"
import script from "./updateDatosParaDebito.vue?vue&type=script&lang=js"
export * from "./updateDatosParaDebito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports